/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export class SystemConfigKeys {
        public static isMonitoringOnlyInstanceEndpoint: string = 'isMonitoring';
        public static hasDigiconEndpoint: string = 'hasDigicon';
        public static isMaintenanceEndpoint: string = 'isMaintenance';
    }

    export interface ISystemConfig {
        id: number;
        key: string;
        index: number;
        type: string;
        value: string;
    }

    export class SystemConfig implements ISystemConfig {
        public id: number;
        public key: string;
        public index: number;
        public type: string;
        public value: string; 
        
        public static Empty(): SystemConfig {
            return new SystemConfig();
        }

        constructor() {
            // empty constructor
            this.id = undefined;
            this.key = '';
            this.index = undefined;
            this.type = '';
            this.value = '';
        }
    }
}
